import React, {Component} from 'react';
import {Card} from 'react-materialize';
import quiz from '../../images/quiz.png';
import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';
import Banner from '../../components/quiz/banner';

class Quiz extends Component {
    render(){
        return(
          <Card>
              <div className="App">
                  <div className="App-header">

                      <div className={"quiz"} align="center">
                          <img src={quiz} className={"center"} alt={"Quiz logo"} width={"100"} height={"100"}/>
                      </div>
                      <div align="center">
                          <h5><b>QUIZ AQUASAFE</b></h5> </div>

                  </div>
              <Banner/>
              </div>

          </Card>
        );
    }
}

export default Quiz;